import { cn } from '@/lib/utils';

interface AuditDiffProps {
  before: Record<string, unknown> | null;
  after: Record<string, unknown> | null;
}

export function AuditDiff({ before, after }: AuditDiffProps) {
  if (!before && !after) {
    return <p className="text-sm text-ndd-500">No snapshot data available</p>;
  }

  const allKeys = new Set([...Object.keys(before ?? {}), ...Object.keys(after ?? {})]);

  return (
    <div className="grid grid-cols-2 gap-4 text-sm">
      <div>
        <p className="text-xs font-semibold text-ndd-400 mb-2 uppercase">Before</p>
        <div className="space-y-1">
          {[...allKeys].map((key) => {
            const beforeVal = before?.[key];
            const afterVal = after?.[key];
            const changed = JSON.stringify(beforeVal) !== JSON.stringify(afterVal);
            return (
              <div
                key={key}
                className={cn(
                  'rounded px-2 py-1',
                  changed ? 'bg-red-900/30 border border-red-800/40' : 'bg-ndd-900/30'
                )}
              >
                <span className="text-ndd-500 text-xs">{key}: </span>
                <span className="text-white">{beforeVal != null ? String(beforeVal) : '—'}</span>
              </div>
            );
          })}
        </div>
      </div>
      <div>
        <p className="text-xs font-semibold text-ndd-400 mb-2 uppercase">After</p>
        <div className="space-y-1">
          {[...allKeys].map((key) => {
            const beforeVal = before?.[key];
            const afterVal = after?.[key];
            const changed = JSON.stringify(beforeVal) !== JSON.stringify(afterVal);
            return (
              <div
                key={key}
                className={cn(
                  'rounded px-2 py-1',
                  changed ? 'bg-ndd-700/30 border border-ndd-600/40' : 'bg-ndd-900/30'
                )}
              >
                <span className="text-ndd-500 text-xs">{key}: </span>
                <span className={cn('text-white', changed && 'font-semibold')}>
                  {afterVal != null ? String(afterVal) : '—'}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
